import { z } from 'zod';

const grammarWorkedExampleSchema = z.object({
  text: z.string(),
  highlight: z.string().optional(),
  commentary: z.string().min(60).max(400),
});

const grammarTeachingConfusionSchema = z.object({
  with: z.string(),
  right: z.string(),
  wrong: z.string().optional(),
  explanation: z.string(),
});

const grammarTeachingRegisterSchema = z.object({
  context: z.string(),
  prefer: z.string(),
  avoid: z.string().optional(),
  note: z.string(),
});

const grammarTeachingExceptionSchema = z.object({
  pattern: z.string(),
  note: z.string(),
  example: z.string(),
});

const grammarTeachingDialectSchema = z.object({
  topic: z.string(),
  american: z.string(),
  british: z.string(),
  verdict: z.string(),
});

const grammarTeachingSchemaDefinition = z.object({
  concept: z.string().min(300).max(1500),
  workedExamples: z.array(grammarWorkedExampleSchema).min(2).max(5),
  confusions: z.array(grammarTeachingConfusionSchema).max(4).optional(),
  register: z.array(grammarTeachingRegisterSchema).max(4).optional(),
  exceptions: z.array(grammarTeachingExceptionSchema).max(6).optional(),
  dialect: z.array(grammarTeachingDialectSchema).max(3).optional(),
});

export const grammarTeachingSchema: typeof grammarTeachingSchemaDefinition =
  grammarTeachingSchemaDefinition;

export type IGrammarTeaching = z.infer<typeof grammarTeachingSchema>;
